var requestOptions = {
  method: "GET",
  redirect: "follow",
};
var discountPrice = 0;

$(function () {
  var fscode = getUrlParameter("discount");
  //console.log('getting discount code from URL: '+fscode);
  if (typeof(fscode) !== 'undefined' && fscode !== null && fscode.length > 0 && fscode != false) {
    $.cookie("discount_code", fscode, { expires: 1, path: '/' });
    window.location.href = '/discount/' + fscode + '?redirect=' + window.location.pathname;
  }

  if ($.cookie("discount_code") != null) {
    //console.log('getting discount code from cookie: '+$.cookie("discount_code"));
    loadDiscount();
  }

  $(document).ajaxComplete(function () {
    loadDiscount();
  });

});

async function loadDiscount() {
  var chn = 4;
  const response = await fetch(
    "https://sales.futuresalad.com/shopify/discounts/" + chn + "/" +
      $.cookie("discount_code"),
    requestOptions
  );
  const discounts = await response.json();
  if (!$.isEmptyObject(discounts.data)) {
    discounts.data.forEach((d) => {
      
      priceItems = $('.price[data-variant-id='+d.vid+']');
      if (!$.isEmptyObject(priceItems)) {
        for (var price of priceItems) {
          if (price.classList.contains("price")){
            originalPrice = $(price.dataset)[0]['price'];
            if (!!originalPrice) {
              price.innerHTML = toPriceHtml(originalPrice, d.dv, chn);
              if (!price.classList.contains("price--on-sale")) {
                $(price).addClass("price--on-sale");
              }
            }
          }
        }
      };
    
    });
  }

  return discountPrice;
}

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function toPriceHtml(inputOriginalPrice, discountValue, lang) {
  var original_price_text = "正常價格";
  var sale_price_text = "特賣價格";
  if (lang != 1){
        original_price_text = "Original";
        sale_price_text = "On Sale";
  }
  var originalPrice = (parseFloat(inputOriginalPrice) / 100.0).toFixed(2);
  var originalPriceText = originalPrice.toString().split(".");
  var discountedPrice = (Math.ceil((1 - (parseFloat(discountValue) * -1 )) * inputOriginalPrice) / 100.0 ).toFixed(2);
  var discountedPriceText = discountedPrice.toString().split(".");
  
  return `<dl>
            <div class="price__regular">
              <dt><span class="visually-hidden visually-hidden--inline">` + original_price_text + `</span></dt>
              <dd><span class="price-item price-item--regular"><price-money><bdi><span class="price__prefix">$</span>`+originalPriceText[0]+`<sup class="price__suffix">.`+originalPriceText[1]+`</sup></bdi></price-money></span></dd>
            </div>
            <div class="price__sale">
              <dt class="price__compare"><span class="visually-hidden visually-hidden--inline">` + original_price_text + `</span></dt>
              <dd class="price__compare"><s class="price-item price-item--regular"><price-money><bdi><span class="price__prefix">$</span>`+originalPriceText[0]+`<sup class="price__suffix">.`+originalPriceText[1]+`</sup></bdi></price-money></s></dd>
              <dt><span class="visually-hidden visually-hidden--inline">` + sale_price_text + `</span></dt>
              <dd><span class="price-item price-item--sale"><price-money><bdi><span class="price__prefix">$</span>`+discountedPriceText[0]+`<sup class="price__suffix">.`+discountedPriceText[1]+`</sup></bdi></price-money></span></dd>
            </div>
          </dl>`;
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};